import React, { useEffect, useState } from "react";
import { Form, message, Row, Col, Skeleton, Tooltip } from "antd";
import { SaveButton, InputText, InputTextArea, CancelButton, ModalComponent, TableComponent, ButtonComponent, SelectWithSearch, trans } from "@comps/components"
import { makeRequest, makeRequestStateless } from "@utils/helpers";
import { Commons, Const } from "../../constants";
import { createDataReq, getPreviewQueryReq, getReportTypesAndTables, getTableInfoByIdReq } from "../requests";
import { createSelectList } from '@comps/commonFunctions';
import { PlayArrowOutlined } from "@mui/icons-material";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { reportTooltips } from "../../common/reportTooltips";
import "./report-builder.css";

const langKey = Const["allReports"].lngKey

const fieldLabel = makeFieldLabel(reportTooltips.report, { namespace: "report", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createRawReport";

const CreateRawReport = (props) => {
  const [loader, setLoader] = useState(false);
  const [saving, setsaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reportTypes, setReportTypes] = useState([]);
  const [allTables, setAllTables] = useState('')
  const [tables, setTables] = useState([])
  const [columns, setColumns] = useState([])
  const [queryResultTable, setQueryResultTable] = useState(null)
  const [queryError, setQueryError] = useState('')
  const [selectedTableId, setSelectedTableId] = useState(null)
  const [running, setRunning] = useState(false)
  let [tempQuery, setTempQuery] = useState('')
  useEffect(() => {
    getRelatedData()
    // eslint-disable-next-line
  }, []);

  //get report types and tables
  const getRelatedData = () => {
    makeRequestStateless(getReportTypesAndTables, null, onSuccessRelatedData, null);
  }
  const onSuccessRelatedData = (data) => {

    setReportTypes(createSelectList(data.report_types))
    setAllTables(data.tables)
    const newTablesList = []
    data.tables.forEach(table => (
      newTablesList.push(
        {
          label: table.table_name,
          value: table.id
        }
      )
    ))
    setTables(newTablesList)
    setLoading(false)
  }

  const onSubmit = (data) => {
    const payload = { ...data, valid: false, query: tempQuery, is_raw_query: true, schema_table_id: selectedTableId }
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    message.success("Saved Successfully");
    props.onCompleted(data.reports.data);
  }

  const onError = (err, res) => {
    setsaving(false)
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  //add query
  const addQuery = (tag, action) => {
    if (action === 'adding') {
      tempQuery += tag + ' '
    }
    if (action === 'typing') {

      tempQuery = tag

    }
    setTempQuery(tempQuery)
  }

  const getTableName = (id) => {
    const table = allTables.filter(each => each.id === id)
    return table[0].table_name
  }
  const onSelectTable = (id) => {
    if (id) {
      setSelectedTableId(id)
      tempQuery = tempQuery === '' ? 'select * from ' : tempQuery
      const tableName = getTableName(id)
      tempQuery += tableName

      setTempQuery(tempQuery)
      makeRequestStateless(getTableInfoByIdReq, id, onGetTableInfo, null);
    }
    else {
      setSelectedTableId(null)
    }
  }
  const onGetTableInfo = (data) => {
    setColumns(data.table.columns)
  }

  const hasQuery = Boolean((tempQuery || '').trim())

  const runQuery = () => {
    setRunning(true)
    const payload = {
      query: tempQuery
    }
    makeRequestStateless(getPreviewQueryReq, payload, onQuerySuccess, onQueryError);
  }
  const onQuerySuccess = (data) => {
    setRunning(false)
    if (data.error !== undefined && data.error) {
      setQueryError(data.error)
      message.error(data.error)
      setQueryResultTable('')
      return
    }

    setQueryError('')
    //show result in table
    const queryColumns = []
    data.columns.forEach(column => {
      queryColumns.push(
        {
          key: column.column_key,
          title: column.display_name,
          dataIndex: column.column_key
        },
      )
    })
    const dataSource = data.report_data

    setQueryResultTable(

      <TableComponent
        scroll={ { x: 'max-content' } }
        loader={ loader }
        columns={ queryColumns }
        dataSource={ dataSource }
        pagination={ false }
      />

    )
  }

  const onQueryError = (err, res) => {

  }


  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 1200 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.rawReport`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <Form { ...formLayout } name={ formName } onFinish={ onSubmit }>

          <div className="report-builder__section">
            <div className="report-builder__section-head">
              <span className="report-builder__section-title">Report Details</span>
              <span className="report-builder__section-rule" />
            </div>
            <Row gutter={ 20 }>
              <Col lg={ 8 } sm={ 24 } xs={ 24 }>
                <Form.Item name="title" rules={ rules.name } label={ fieldLabel("title", trans(`${langKey}.name`)) }>
                  <InputText placeholder="Name" />
                </Form.Item>
              </Col>
              <Col lg={ 8 } sm={ 24 } xs={ 24 }>
                <Form.Item name="report_type_id" label={ fieldLabel("report_type_id", trans(`${langKey}.report_type_id`)) } rules={ rules.report_type_id }>
                  <SelectWithSearch
                    placeholder={ trans(`${langKey}.report_type_id`) }
                    options={ reportTypes } />
                </Form.Item>
              </Col>
              <Col lg={ 8 } sm={ 24 } xs={ 24 }>
                <Form.Item name="schema_table_id" label={ fieldLabel("schema_table_id", trans(`${langKey}.schema_table_id`)) }>
                  <SelectWithSearch
                    placeholder={ trans(`${langKey}.schema_table_id`) }
                    options={ tables }
                    onChange={ onSelectTable }
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="report-builder__section">
            <div className="report-builder__section-head">
              <span className="report-builder__section-title">Query Builder</span>
              <span className="report-builder__section-hint">Pick a table to list its columns, click a column to append it to the query, then run to preview.</span>
              <span className="report-builder__section-rule" />
            </div>
            <Row gutter={ 20 }>
              <Col lg={ 7 } sm={ 24 } xs={ 24 }>
                <div className="report-builder__card">
                  <div className="report-builder__card-head">
                    <span className="report-builder__card-title">Columns</span>
                    <span className="report-builder__count">{ columns.length }</span>
                  </div>
                  <div className="report-builder__card-body report-builder__card-body--scroll">
                    { columns.length ? (
                      <ul className="report-builder__chips">
                        { columns.map(each => (
                          <li key={ each.column_name }>
                            <Tooltip title={ each.column_name }>
                              <ButtonComponent
                                className="report-builder__chip"
                                onClick={ () => addQuery(each.column_name, 'adding') }
                              >
                                { each.display_name }
                              </ButtonComponent>
                            </Tooltip>
                          </li>
                        )) }
                      </ul>
                    ) : (
                      <div className="report-builder__empty">Select a table to see its columns</div>
                    ) }
                  </div>
                </div>
              </Col>
              <Col lg={ 17 } sm={ 24 } xs={ 24 }>
                <div className="report-builder__card">
                  <div className="report-builder__card-head">
                    <span className="report-builder__card-title">SQL Query</span>
                    <Tooltip title={ hasQuery ? "Run Query" : "Type a query to run" }>
                      <span>
                        <ButtonComponent
                          className="report-builder__run-btn"
                          icon={ <PlayArrowOutlined fontSize="small" /> }
                          onClick={ runQuery }
                          type="primary"
                          loading={ running }
                          disabled={ !hasQuery }
                          text="Run"
                        />
                      </span>
                    </Tooltip>
                  </div>
                  <div className="report-builder__card-body report-builder__sql-body">
                    { /* kept outside Form.Item on purpose: the query text lives in
                         `tempQuery` and is attached to the payload on submit */ }
                    <InputTextArea
                      className="report-builder__sql-input"
                      value={ tempQuery }
                      onChange={ (e) => addQuery(e.target.value, 'typing') }
                      placeholder="Type Sql Query"
                    />
                  </div>
                </div>
                { queryError ? <div className="report-builder__error">{ queryError }</div> : null }
                { queryResultTable ? <div className="report-builder__result">{ queryResultTable }</div> : null }
              </Col>
            </Row>
          </div>

        </Form>
      </Skeleton>
    </ModalComponent>
  )
}

export default CreateRawReport

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name.required`) },
  ],
  report_type_id: [
    { required: true, message: trans(`${langKey}.report_type_id.req`) },
  ],
  schema_table_id: [
    { required: true, message: trans(`${langKey}.schema_table_id.req`) },
  ]
};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
};
